// ==================================
// reducer/competitorAiTableReducer.js
// ==================================

import {
  GENERATE_AI_TABLE_REQUEST,
  GENERATE_AI_TABLE_SUCCESS,
  GENERATE_AI_TABLE_FAILURE,
} from "../actions/competitorAiTableActions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const competitorAiTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERATE_AI_TABLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GENERATE_AI_TABLE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case GENERATE_AI_TABLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default competitorAiTableReducer;
